var _path, _path2, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFbtctz(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 32,
    viewBox: "0 0 28 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2070_19372)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.601562 8.36881L13.818 0.738281L27.0345 8.36881V23.6299L13.818 31.2604L0.601562 23.6299V8.36881Z",
    stroke: "url(#paint0_linear_2070_19372)",
    strokeWidth: 1.45455
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2070_19372",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 2,
    y: 2,
    width: 24,
    height: 28
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.8178 2.87109L25.1864 9.43473V22.562L13.8178 29.1256L2.44922 22.562V9.43473L13.8178 2.87109Z",
    fill: "#C4C4C4"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2070_19372)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.8182 29.818C21.4498 29.818 27.6364 23.6314 27.6364 15.9998C27.6364 8.36825 21.4498 2.18164 13.8182 2.18164C6.18661 2.18164 0 8.36825 0 15.9998C0 23.6314 6.18661 29.818 13.8182 29.818Z",
    fill: "#F2F2F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14 30C21.732 30 28 23.732 28 16C28 8.26801 21.732 2 14 2C6.26801 2 0 8.26801 0 16C0 23.732 6.26801 30 14 30Z",
    fill: "#F2F2F2"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_2070_19372)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.9079 28.3158C20.6225 28.3158 26.0658 22.8725 26.0658 16.1579C26.0658 9.44327 20.6225 4 13.9079 4C7.19327 4 1.75 9.44327 1.75 16.1579C1.75 22.8725 7.19327 28.3158 13.9079 28.3158Z",
    fill: "#F2F2F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.9082 24.6095C18.5757 24.6095 22.3595 20.8257 22.3595 16.1582C22.3595 11.4908 18.5757 7.70703 13.9082 7.70703C9.24077 7.70703 5.45703 11.4908 5.45703 16.1582C5.45703 20.8257 9.24077 24.6095 13.9082 24.6095Z",
    stroke: "black",
    strokeOpacity: 0.67,
    strokeWidth: 1.46341
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.5835 12.8945H3.23301C2.57793 12.8945 2.04688 13.4256 2.04688 14.0807V18.0246C2.04688 18.6797 2.57793 19.2107 3.23301 19.2107H24.5835C25.2385 19.2107 25.7696 18.6797 25.7696 18.0246V14.0807C25.7696 13.4256 25.2385 12.8945 24.5835 12.8945Z",
    fill: "#F2F2F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.5835 12.8945H3.23301C2.57793 12.8945 2.04688 13.4256 2.04688 14.0807V18.0246C2.04688 18.6797 2.57793 19.2107 3.23301 19.2107H24.5835C25.2385 19.2107 25.7696 18.6797 25.7696 18.0246V14.0807C25.7696 13.4256 25.2385 12.8945 24.5835 12.8945Z",
    fill: "#F2F2F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.9084 27.4253C20.1317 27.4253 25.1767 22.3803 25.1767 16.157C25.1767 9.93366 20.1317 4.88867 13.9084 4.88867C7.68512 4.88867 2.64014 9.93366 2.64014 16.157C2.64014 22.3803 7.68512 27.4253 13.9084 27.4253Z",
    stroke: "#F2F2F2",
    strokeWidth: 1.7561
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.9085 26.5367C19.6405 26.5367 24.2872 21.89 24.2872 16.158C24.2872 10.426 19.6405 5.7793 13.9085 5.7793C8.17648 5.7793 3.52979 10.426 3.52979 16.158C3.52979 21.89 8.17648 26.5367 13.9085 26.5367Z",
    stroke: "#F2F2F2",
    strokeWidth: 0.585366
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.908 26.979C19.8856 26.979 24.7315 22.1332 24.7315 16.1555C24.7315 10.1779 19.8856 5.33203 13.908 5.33203C7.93031 5.33203 3.08447 10.1779 3.08447 16.1555C3.08447 22.1332 7.93031 26.979 13.908 26.979Z",
    stroke: "#F2F2F2",
    strokeWidth: 0.878049
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.3487 15.8291C16.8934 15.5518 17.2343 15.0635 17.1546 14.25C17.0474 13.1382 16.0867 12.7655 14.8738 12.6593L14.8736 11.1172H13.9339L13.9336 12.6187C13.6864 12.6187 13.4343 12.6236 13.1834 12.6286L13.1832 11.1174L12.2444 11.1173L12.2442 12.659C12.0407 12.6632 11.8409 12.6671 11.6458 12.6671V12.6626L10.3496 12.662L10.3498 13.6644C10.3498 13.6644 11.0437 13.6514 11.0323 13.664C11.4128 13.6643 11.537 13.885 11.5728 14.0756L11.5731 15.8324V18.3001C11.5563 18.4196 11.4858 18.6107 11.2198 18.6111C11.2319 18.6217 10.5362 18.6109 10.5362 18.6109L10.3498 19.7318H11.5725C11.8003 19.7321 12.0242 19.7356 12.2438 19.7374L12.2446 21.2969L13.1832 21.2972L13.183 19.754C13.4412 19.7593 13.6905 19.7615 13.9339 19.7612L13.9337 21.2972H14.8734L14.8739 19.7402C16.4534 19.6496 17.5593 19.252 17.6967 17.77C17.8076 16.5768 17.2455 16.0441 16.3487 15.8291ZM13.2059 13.7321C13.7359 13.7321 15.4027 13.5634 15.4029 14.6696C15.4027 15.7301 13.7364 15.6062 13.2059 15.6062V13.7321ZM13.2055 18.6187L13.2059 16.5523C13.8427 16.5521 15.8399 16.3692 15.8401 17.585C15.8404 18.7509 13.8427 18.6182 13.2055 18.6187Z",
    fill: "black",
    fillOpacity: 0.67
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2070_19372",
    x1: -9.31078,
    y1: 15.9994,
    x2: 30.3386,
    y2: 15.9994,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#05E3B2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.184658,
    stopColor: "#39E4B8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8C7BCC"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2070_19372"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 27.6364,
    height: 32,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_2070_19372"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24.3158,
    height: 24.3158,
    fill: "white",
    transform: "translate(1.75 4)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFbtctz);
export default __webpack_public_path__ + "static/media/fbtctz.139b39af2e84168c37e7952094ebb298.svg";
export { ForwardRef as ReactComponent };